import React from 'react';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { createIdFromLabel, generateRandomId } from '../../../utils/commonUtils';

const CustomRadioWithCustomValues = (props) => {
  const { item, handleRadioButton, options } = props;
  const fieldId = item.fieldName ? createIdFromLabel(item.fieldName) : generateRandomId();

  const onChange = (e) => {
    const inputValue = e.target.value;
    const currField = { ...item };
    currField.value = inputValue;
    handleRadioButton(currField);
  };

  return (
    <div className='custom-active-inactive-radio'>
      <RadioGroup
        row
        aria-label={fieldId}
        onChange={(e) => {
          onChange(e);
        }}
        defaultValue={item.value}
        value={item.value}
        className='hotel-service-radio-group d-flex flex-column'
        name={fieldId}
      >
        {options.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option.id}
            control={<Radio color='primary' />}
            label={option.name}
            className='me-5'
          />
        ))}
      </RadioGroup>
    </div>
  );
};

export default CustomRadioWithCustomValues;
